var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppraisal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0547 35.1562H88.8672V78.125H81.0547V35.1562Z",
    fill: "#6E83B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9141 35.1562H90.8203V56.6406H86.9141V35.1562Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0547 33.2031H88.8672V35.1562H81.0547V33.2031Z",
    fill: "#466089"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0547 33.2031H88.8672V29.2969C88.8672 27.1395 87.1184 25.3906 84.9609 25.3906C82.8035 25.3906 81.0547 27.1395 81.0547 29.2969V33.2031Z",
    fill: "#6E83B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8672 78.125L84.9609 85.9375L81.0547 78.125H88.8672Z",
    fill: "#466089"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17969 10.9375H81.0547V98.0469H9.17969V10.9375Z",
    fill: "#EDEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1484 8.98438C52.1484 5.10723 48.9943 1.95312 45.1172 1.95312C41.24 1.95312 38.0859 5.10723 38.0859 8.98438H25.5859V17.1875H64.6484V8.98438H52.1484Z",
    fill: "#6E83B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1172 12.4023C47.0049 12.4023 48.5352 10.8721 48.5352 8.98438C48.5352 7.09668 47.0049 5.56641 45.1172 5.56641C43.2295 5.56641 41.6992 7.09668 41.6992 8.98438C41.6992 10.8721 43.2295 12.4023 45.1172 12.4023Z",
    fill: "#466089"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6758 44.7266H71.9727V47.4609H42.6758V44.7266Z",
    fill: "#D3D3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6758 34.4031H71.9727V37.1375H42.6758V34.4031Z",
    fill: "#D3D3D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6758 24.0795H71.9727V26.8139H42.6758V24.0795Z",
    fill: "#D3D3D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.793 24.0234V47.4609H18.2617V24.0234H37.793Z",
    fill: "#80D6FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 37.6953C30.7129 37.6953 32.9102 35.498 32.9102 32.8125C32.9102 30.127 30.7129 27.9297 28.0273 27.9297C25.3418 27.9297 23.1445 30.127 23.1445 32.8125C23.1445 35.498 25.3418 37.6953 28.0273 37.6953Z",
    fill: "#6E83B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.793 47.4609C37.793 42.0898 33.3984 37.6953 28.0273 37.6953C22.6562 37.6953 18.2617 42.0898 18.2617 47.4609H37.793Z",
    fill: "#6E83B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2617 61.9141H31.9336V75.5859H18.2617V61.9141Z",
    fill: "#80D6FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6328 73.0607L20.0127 69.4404L21.3936 68.0596L23.6328 70.2986L28.8018 65.1299L30.1826 66.5107L23.6328 73.0607Z",
    fill: "#6E83B7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2617 77.5391H31.9336V91.2109H18.2617V77.5391Z",
    fill: "#80D6FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6328 88.6857L20.0127 85.0654L21.3936 83.6846L23.6328 85.9236L28.8018 80.7549L30.1826 82.1357L23.6328 88.6857Z",
    fill: "#6E83B7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9727 91.2109H38.7695V61.9141H41.5039V88.4766H71.9727V91.2109Z",
    fill: "#6E83B7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9609 68.6523H64.2578V85.2539H59.9609V68.6523Z",
    fill: "#80D6FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6758 65.7227H71.9727V85.2539H67.6758V65.7227Z",
    fill: "#46BEE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2461 71.582H56.543V85.2539H52.2461V71.582Z",
    fill: "#46BEE8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5312 74.5117H48.8281V85.2539H44.5312V74.5117Z",
    fill: "#80D6FB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6328 50.4883L24.9908 53.2529L28.0273 53.6963L25.8301 55.848L26.3488 58.8867L23.6328 57.4521L20.9168 58.8867L21.4355 55.848L19.2383 53.6963L22.2748 53.2529L23.6328 50.4883Z",
    fill: "#6E83B7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6016 50.4883L67.9596 53.2529L70.9961 53.6963L68.7988 55.848L69.3176 58.8867L66.6016 57.4521L63.8855 58.8867L64.4043 55.848L62.207 53.6963L65.2436 53.2529L66.6016 50.4883Z",
    fill: "#6E83B7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9561 50.4883L39.3141 53.2529L42.3506 53.6963L40.1533 55.848L40.6721 58.8867L37.9561 57.4521L35.2402 58.8867L35.7588 55.848L33.5615 53.6963L36.598 53.2529L37.9561 50.4883Z",
    fill: "#6E83B7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2783 50.4883L53.6363 53.2529L56.6728 53.6963L54.4756 55.848L54.9941 58.8867L52.2783 57.4521L49.5623 58.8867L50.0811 55.848L47.8838 53.6963L50.9203 53.2529L52.2783 50.4883Z",
    fill: "#6E83B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppraisal);
export default __webpack_public_path__ + "static/media/appraisal.a37d5a8588b6864ed1a7f3cc23128af9.svg";
export { ForwardRef as ReactComponent };